import { render, staticRenderFns } from "./pwa-snackbar-icon.vue?vue&type=template&id=94b1234c&"
import script from "./pwa-snackbar-icon.vue?vue&type=script&lang=js&"
export * from "./pwa-snackbar-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports